<template>
	<button :class="classes" :disabled="disabled" @click="handleClick">
		<span v-if="showSlot" ref="slot">
			<slot></slot>
		</span>
	</button>
</template>
<script>
const prefix = 'eagle-btn'
export default {
	data() {
		return {
			showSlot: true,
		}
	},
	props: {
		type: {
			validator(value) {
				return ['primary', 'default'].includes(value)
			},
			default: 'default',
		},
		round: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		classes() {
			return (
				`${prefix} ${prefix}--${this.type}` + (this.round ? ' is-round' : '')
			)
		},
	},
	methods: {
		handleClick(ev) {
			this.$emit('click', ev)
		},
	},
	mounted() {
		this.showSlot = this.$slots.default !== undefined
	},
}
</script>
<style lang="scss" scoped>
$primary: #107ffc;
$primaryHover: #57a6ff;

.eagle-btn {
	display: inline-block;
	line-height: 1;
	white-space: nowrap;
	cursor: pointer;
	background: rgb(255, 255, 255);
	border: 1px solid rgb(220, 223, 230);
	color: rgb(96, 98, 102);
	-webkit-appearance: none;
	text-align: center;
	box-sizing: border-box;
	outline: none;
	margin: 0;
	transition: 0.1s;
	font-weight: 500;
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	padding: 12px 20px;
	font-size: 14px;
	border-radius: 4px;
}
.eagle-btn.is-round {
	border-radius: 24.5px;
}
.eagle-btn--default {
	color: $primary;
	border-color: $primary;
	background: #fff;
	&:focus,
	&:hover {
		color: $primaryHover;
		border-color: $primaryHover;
	}
}
.eagle-btn--primary {
	color: #fff;
	background-color: $primary;
	border-color: $primary;
	&:focus,
	&:hover {
		color: #fff;
		background-color: $primaryHover;
		border-color: $primaryHover;
	}
}
</style>
